import React, { useState, useEffect, useRef } from "react";
import { Modal, Tooltip } from "antd";
import parse from "html-react-parser";

import Commands from "./CommandHelp";
import { useAugnito } from "./AugnitoClient";

const MENU_OPTIONS = {
  commands: "commands",
  qrcode: "qrcode",
};

export const AugnitoBot = ({ userTag }) => {
  const [qrCodeHtml, setQrCodeHtml] = useState(null);
  const [modal, setModal] = useState({
    visible: false,
    type: null,
  });
  const [showErrorTooltip, setShowErrorTooltip] = useState(false);
  const {
    startAugnitoConnection,
    stopAugnitoConnection,
    isConnected,
    isError,
    getQRCode,
  } = useAugnito({ userTag: userTag });
  const isConnectedRef = useRef(isConnected);
  const stopAugnitoRef = useRef(stopAugnitoConnection);
  const startAugnitoRef = useRef(startAugnitoConnection);

  useEffect(() => {
    isConnectedRef.current = isConnected;
  }, [isConnected]);

  useEffect(() => {
    if (isError) {
      setShowErrorTooltip(true);
      const timer = setTimeout(() => {
        setShowErrorTooltip(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isError, isConnected]);

  useEffect(() => {
    stopAugnitoRef.current = stopAugnitoConnection;
  }, [stopAugnitoConnection]);

  useEffect(() => {
    window.addEventListener("DICTATION_SPM_EVENT", (event) =>
      dispatchEvent(event.detail.event)
    );

    return () => {
      window.removeEventListener("DICTATION_SPM_EVENT", dispatchEvent());
    };
  }, []);

  const stopAugnito = () => {
    const isConnectedState = isConnectedRef.current;

    if (isConnectedState) {
      stopAugnitoRef.current();
    }
  };

  const dispatchEvent = (key) => {
    if (!key) {
      stopAugnito();
    } else {
      const startAugnitoFun = startAugnitoRef.current;
      const startActions = ["F3_C"];

      if (startActions.includes(key)) {
        startAugnitoFun();
      }
    }
  };

  const openMenuOptions = () => {
    var popup = document.getElementById("menuOptions");

    popup.classList.toggle("show");
  };

  const showModalHandler = (value) => {
    if (value.type === MENU_OPTIONS.qrcode) {
      generateQRCode();
    }

    setModal(value);
  };

  const generateQRCode = () => {
    const qrCodeDiv = document.createElement("div");
    qrCodeDiv.setAttribute("id", "qrcode");
    new window.QRCode(qrCodeDiv, getQRCode());
    setTimeout(() => setQrCodeHtml(qrCodeDiv.outerHTML), 500);
  };

  const augnitoClickHanlder = () => {
    if (isConnected) {
      stopAugnitoRef.current();
    } else {
      startAugnitoRef.current();
    }
  };

  let toolTipText = null;
  if (isError) {
    toolTipText =
      "Augnito connection failed and is stopping. Please contact support.";
  } else if (isConnected) {
    toolTipText = "Connected and listening!";
  }

  const showTooltip = isConnected || showErrorTooltip;

  const QRCode = () => {
    return (
      <div id="QRCodeDialog" title="">
        <div className="QRCodeParent">
          <div className="ScanQRCodeWithAugnitoMic" style={{ marginBottom: 5 }}>
            Scan QR code with Augnito Mic
          </div>

          <div
            style={{
              padding: "8px",
              backgroundColor: "white",
              justifyContent: "center",
              display: "flex",
            }}
          >
            {qrCodeHtml && parse(qrCodeHtml)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div id="augnitoMicBar" class="floatingWindow">
        <div className="augnitoFloatingParentElementStyle">
          <div className="FloatingHyperText" id="FloatingHyperText" />

          <Tooltip
            title={toolTipText}
            visible={showTooltip}
            placement="topLeft"
            overlayStyle={{
              zIndex: 9999,
            }}
          />

          <span
            id="btnAugnitoMic"
            className={
              isConnected
                ? "AugnitoStopButtonStyle AugnitoStartButtonStyle"
                : "AugnitoStopButtonStyle"
            }
            onClick={augnitoClickHanlder}
          />

          <div className="MenuWrapper popup" onClick={openMenuOptions}>
            <div className="popuptext" id="menuOptions">
              <ul className="popupSubMenu">
                <li
                  onClick={() =>
                    showModalHandler({
                      visible: true,
                      type: MENU_OPTIONS.commands,
                    })
                  }
                >
                  Command Help
                </li>
                <li
                  onClick={() =>
                    showModalHandler({
                      visible: true,
                      type: MENU_OPTIONS.qrcode,
                    })
                  }
                >
                  Pair mic
                </li>
              </ul>
            </div>
            <span className="MenuIcon">...</span>
          </div>
        </div>
      </div>

      <Modal
        id="augnito-info-modal"
        title={
          modal.type === MENU_OPTIONS.commands ? "Command Help" : "Pair Mic"
        }
        visible={modal.visible}
        onCancel={() => showModalHandler({ visible: false, type: null })}
        style={{ top: 10 }}
        footer={null}
        bodyStyle={{ maxHeight: 500, overflowY: "auto" }}
      >
        {modal.type === MENU_OPTIONS.commands ? (
          <Commands />
        ) : modal.type === MENU_OPTIONS.qrcode ? (
          <QRCode />
        ) : null}
      </Modal>
    </>
  );
};
